import React from "react";

const Sidebar: React.FC = () => {
  return <div>Sidebar</div>;
};

export default Sidebar;
